// extracted by mini-css-extract-plugin
export default {"notification-badge":"NotificationBadge_notification-badge__DRYKL","--hidden":"NotificationBadge_--hidden__k27TL","--selected":"NotificationBadge_--selected__A4J+z"};